<template>
  <div :class="b()">
    <button v-show="!isEdit" @click="setEdit(true)">Присоединиться</button>
    <div v-show="isEdit" :class="b('edit-number')">
      <number-counter-component v-model="value" @input="updateValue"></number-counter-component>
      <div :class="b('edit-btn')">
        <button @click="makeJoin">Принять</button>
        <button @click="setEdit(false)">Отменить</button>
      </div>
    </div>
  </div>
</template>

<script>
    import NumberCounterComponent from "./NumberCounterComponent";
    import BuyingService from "../services/BuyingService";

    const COMPONENT_NAME = "collective-join";


    export default {
        components: {NumberCounterComponent},
        props: ['buyingId', 'buyingType', 'buyingItem', 'isDemoUser'],
        data() {
            return {
                isEdit: false,
                value: 1
            };
        },
        name: COMPONENT_NAME,
        methods: {
            updateValue(value) {
                this.value = value;
            },
            async makeJoin() {
               if(this.isDemoUser) {
                  this.$notify({message: 'Присоединиться к закупке может только зарегистрированный!', type: 'error'});
                  $('.signupBuyer').click();
                  return;
                }

                let response = await BuyingService.joinToBuying(this.buyingId, this.buyingType, this.buyingItem.prototypeId, this.value);
                if (response.success) {
                    this.$emit('join-success');
                } else {
                    this.$message(response.error.message);
                }
            },
            setEdit(value) {
                this.isEdit = value;
            }
        }
    }
</script>

<style lang="scss" scoped>
  .collective-join {
    display: flex;
    flex-direction: column;

    &__edit-number {
      display: flex;
      flex-direction: column;
    }

    &__edit-btn {
      display: flex;
      align-items: flex-end;

      button {
        margin-right: 5px;
      }
    }
  }
</style>